import { connect } from 'react-redux'
import SeenUI from './SeenUI'
import { Dispatch } from 'redux';
import BookmarkDispatch from './model';
import ApplicationState from '../../../../../../../ApplicationState';
import IState from '../../../../../../Util/IState';
import IDispatcher from '../../../../../../Util/IDispatcher';
import { ActionType } from '../../Actions/ActionTypes';
import VilgramFileDto from '../../../../../../../dto/VilagramFileDto';
import { ActionType as FileActionTypes } from '../../../File/Actions/ActionTypes';
import SeenState from '../../State/SeenState';

const mapStateToProps = (state: ApplicationState): IState<SeenState> => {
    return {
        state: state.seen
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<BookmarkDispatch> => ({
    dispatcher: {
        show: () => {
            dispatch({
                type: ActionType.SEEN_SHOW
            })
        },
        onItemClicked: (file: VilgramFileDto) => {
            dispatch({
                type: FileActionTypes.FILE_SHOW,
                data: file
            })
        }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(SeenUI)